import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { af, bareButtonCss, hoverQuery } from '../theme';

const styles = {
  /**
   * One per screen. The 22px radius on a 56px button is a ratio of 0.39 — visibly
   * rounded with a straight run. It is not a pill; pills are reserved for the toggle
   * and chips.
   */
  root: css`
    ${bareButtonCss};
    width: 100%;
    min-height: 56px;
    border-radius: ${af.rBtn};
    background: ${af.ink};
    color: ${af.paper};
    margin-top: ${af.sp6};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${af.sp2};
    transition: background 0.12s ease;

    svg {
      width: 16px;
      height: 16px;
      flex: 0 0 16px;
    }

    /* Pointer devices only: on touch the darkened state would stay after the tap. */
    ${hoverQuery} {
      &:not(:disabled):hover {
        background: #333;
      }
    }

    /* Paper with an inset hairline, never a faded fill. */
    &:disabled {
      background: ${af.paper};
      box-shadow: inset 0 0 0 1px ${af.line};
      cursor: not-allowed;
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
